// extracted by mini-css-extract-plugin
export default {"content":"InfoBody_content__jfmAW"};